import { PropsWithChildren } from "react";

import { View } from "react-native";
import { Button, Icon, Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import Modal from "../../../../components/Modal";

type Props = {
  visible: boolean;
  onDismiss: () => void;
};
export default function InfoModal({ visible, onDismiss }: Props) {
  const tailwind = useTailwind();
  const { colors } = useTheme();
  const backgroundColor = colors.surface;

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      contentContainerStyle={[tailwind("p-6 gap-4"), { backgroundColor }]}
      showClose
    >
      <Header />
      <Content />
      <Button style={tailwind("self-end")} onPress={onDismiss}>
        Cerrar
      </Button>
    </Modal>
  );
}

function Header() {
  const tailwind = useTailwind();
  const { colors } = useTheme();
  return (
    <View style={tailwind("items-center gap-2")}>
      <Icon source="truck-fast-outline" size={24} color={colors.secondary} />
      <Text variant="headlineSmall" style={tailwind("text-center")}>
        ¿Cómo funcionan los envíos automáticos?
      </Text>
    </View>
  );
}

function Content() {
  const tailwind = useTailwind();
  return (
    <View style={tailwind("gap-2")}>
      <Item title="Recogemos en tu ubicación">
        Indícanos dónde quieres que recojamos tus pedidos. Nuestro socio
        logístico pasará en el rango establecido según tu área.
      </Item>
      <Item title='Marca "Listo para recoger"'>
        Al indicarlo en los detalles del pedido obtendrás un número de rastreo
        para el paquete.
      </Item>
      <Item title="Costo del servicio">
        Este servicio tiene un costo de <Bold>5.1%</Bold> del valor de la
        transacción.
      </Item>
      <Item title="Rastreo en tiempo real">
        Tu cliente podrá seguir su pedido en todo momento.
      </Item>
      <Item title="Múltiples intentos de entrega">
        Realizamos hasta dos intentos de entrega.
      </Item>
    </View>
  );
}

function Item({ title, children }: PropsWithChildren<{ title: string }>) {
  const tailwind = useTailwind();
  return (
    <View>
      <View style={tailwind("flex-row items-center gap-2")}>
        <Text variant="bodyLarge" style={tailwind("font-bold")}>
          • {title}
        </Text>
      </View>
      <Text variant="bodyMedium" style={tailwind("pl-3")}>
        {children}
      </Text>
    </View>
  );
}

function Bold({ children }: PropsWithChildren) {
  const tailwind = useTailwind();
  return <Text style={tailwind("font-bold")}>{children}</Text>;
}
